<div *ngIf="isSpinnerLoad" class="spinner-container">
  <mat-spinner [diameter]="50"> </mat-spinner>
</div>
<app-layout *ngIf="!isForPrintPreview"></app-layout>
<router-outlet *ngIf="isForPrintPreview"></router-outlet>
